export const travelersInfo = {
  "lastName": "",
  "firstName": "",
  "birthDate": "",
  "gender": "",
  "type": "ADT",
  "phone": [
      {
          "countryCode": "",
          "location": "",
          "number": ""
      }
  ],
  "email": "",
  "document": {
      "documentType": "Passport",
      "birthPlace": "",
      "issuanceLocation": "",
      "issuanceDate": "",
      "number": "",
      "expiryDate": "",
      "issuanceCountry": "",
      "validityCountry": "",
      "nationality": "",
      "holder": true
  },
  frequentFlyer: '',
  generalRemark: '',
}